import type { Block } from '../../../../types/proposal-blocks';
import { renderMarkdown } from './markdown';

type Data = Extract<Block, { type: 'section' }>;

export function SectionBlock({ block }: { block: Data }) {
  return (
    <div id={block.id} className="mb-10">
      <h2 className="text-[22px] font-bold tracking-tight text-proposal-fg1 leading-tight mb-2">
        {block.title}
      </h2>
      {block.subtitle && (
        <p className="text-sm text-proposal-fg2 font-proposal-mono mb-4">{block.subtitle}</p>
      )}
      <div>{renderMarkdown(block.body_md)}</div>
    </div>
  );
}
